import axios from "../api/axiosInstance";

export const GetAllProduct = async () => {
    return await axios.get("/Product/GetProductList");
};

export const GetActiveProduct  = async () => {
    return await axios.get("/Product/GetActiveProductList");
};

export const GetProductById = async (id) => {
    return await axios.get("/Product/GetProductById", {
        params: { id }
    });
};

export const GetProductByName = async (name) => {
    return await axios.get("/Product/GetProductByName", {
        params: { name }
    });
};

export const AddProduct = async (model) => {
    return await axios.post("/Product/AddProduct", model);
};

export const UpdateProduct = async (model) => {
    return await axios.post("/Product/UpdateProduct", model);
};

export const RemoveProduct = async (id, confirmDelete = false) => {
    return await axios.post("/Product/RemoveProduct", null, {
        params: { id, confirmDelete }
    });
};